import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue';
import type { ResourceId } from '@/venit/services/model/techpubs-cms';
import ResourcePreviewVenit from '@/venit/components/cortona-venit/components/cortona/Model.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'resource-preview-dialog',
  props: {
    previewTitle: {},
    previewSrc: {},
    iframeStyle: { default: 'height: 75vh; width: 85vw' },
    previewDialog: { type: Boolean },
    resourceId: {},
    autoSelectView: {},
    autoSelectPart: {}
  },
  emits: ["closeDialog"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dialogVisible = ref(false);

watch(() => props.previewDialog, (newValue) => { dialogVisible.value = newValue; }, { immediate: true });
watch(dialogVisible, (newValue) => { if (!newValue) closePreviewDialog(); });

const closePreviewDialog = () => emit('closeDialog');

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dialog z podglądem resource'a "),
    _createVNode(_component_v_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      scrollable: "",
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        true
          ? (_openBlock(), _createBlock(ResourcePreviewVenit, {
              key: 0,
              id: __props.resourceId?.uuid,
              vin: null,
              autoSelectView: props.autoSelectView,
              autoSelectPart: props.autoSelectPart,
              onCloseDialog: closePreviewDialog
            }, null, 8 /* PROPS */, ["id", "autoSelectView", "autoSelectPart"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})